const domain = 'custlogin.gm.com'
const policy = 'B2C_1A_SeamlessMigration_SignUpOrSignIn'

export const MSalProdConfig = {
	approvedAuthorities: [domain],
	authority: `https://${domain}/gmb2cprod.onmicrosoft.com/${policy}`,
	clientID: '43b9895e-a54a-412e-b11d-eaf11dac570d',
	policy,
	tenant: domain,
}
